import React from 'react'

import { MenuItemsCarousel } from '@peracto/peracto-blocks-tailwind'
import Form from './Form/MenuItemsCarouselForm'
import { defaultSettings } from './defaults/settings'

const createPlugin = settings => {
    const mergedSettings = { ...defaultSettings, ...settings }
    const RenderComponent = MenuItemsCarousel

    return {
        FormComponent: props => <Form {...props} />,
        Component: props => <RenderComponent.Component {...props} {...mergedSettings} />,

        name: 'peracto/content/menuItemsCarousel',
        version: '1.0.0',
        text: mergedSettings.translations.pluginName,
        description: mergedSettings.translations.pluginDescription,
        IconComponent: mergedSettings.IconComponent,

        createInitialState: () => ({
            menu: {},
            menuItem: {},
            menuItemPath: null,
            categoryPath: null,
            cardStyle: 'square',
            progressIndicatorStyle: 'dots',
            imageFit: 'cover',
            font: '',
            fontWeight: 'normal',
            fontColour: '#000',
            accentColour: '#000',
            arrowColour: '#FFFFFF',
            fallbackImage: '',
        }),
    }
}

export default createPlugin
